import React from "react";

import { Body2 } from "Theme/BodyText";

const OwnerOrEmployeesMessage = () => (
  <Body2 color="error">
    You must offer benefits at least <b>1 full-time owner</b> or <b>2 people</b> (owners, contractors, and/or employees) to continue.&nbsp;
  </Body2>
);

const EmployeesOnlyMessage = () => (
  <Body2 componentClass="p" color="error" pt={3}>
    At least <b>2 people</b> (owners, contractors, and/or employees) need to be offered benefits.
  </Body2>
);

type MinimumEmployeesMessageProps = {
  hasMinimumEmployees: boolean;
  allowSingleOwner: boolean;
};

const MinimumEmployeesMessage = ({ hasMinimumEmployees, allowSingleOwner }: MinimumEmployeesMessageProps) => {
  if (hasMinimumEmployees) {
    return <div />;
  }
  if (allowSingleOwner && !hasMinimumEmployees) {
    return <OwnerOrEmployeesMessage />;
  }
  return <EmployeesOnlyMessage />;
};

export default MinimumEmployeesMessage;
